import type { ScoredResult, IntakeData } from '../engine/types';

const BAND_LABEL: Record<string, string> = {
  'at-risk': 'At Risk',
  maturing: 'Maturing',
  mature: 'Mature',
};

export function buildHubSpotNoteForBoardAiLiteracy(result: ScoredResult, _intake: IntakeData): string {
  const axes = result.score as Record<string, number>;
  const lines: string[] = [
    '## Board AI Literacy Index result',
    '',
    `**Submitted:** ${result.submittedAt}`,
    `**Result URL:** https://innovatexsolutions.com.au/assessments/board-ai-literacy/result/${result.uuid}/`,
    '',
    '### Scores',
    `- Composite: ${result.composite ?? 0} / 100 → **${BAND_LABEL[result.band] ?? result.band}**`,
    `- Governance Maturity: ${axes.governance ?? 0} / 100`,
    `- Director Capability: ${axes.capability ?? 0} / 100`,
  ];
  if (result.archetype) lines.push(`- Archetype: ${result.archetype}`);
  lines.push('');
  if (result.coverage) {
    lines.push('### Coverage');
    lines.push(`- Governance: ${Math.round((result.coverage.governance ?? 1) * 100)}%`);
    lines.push(`- Capability: ${Math.round((result.coverage.capability ?? 1) * 100)}%`);
    if (result.coverageFlags?.length) {
      lines.push(`- Flags: ${result.coverageFlags.join(', ')}`);
    }
    lines.push('');
  }
  return lines.join('\n');
}
